import { Component, OnInit } from '@angular/core';
import { Title, Meta } from '@angular/platform-browser';

@Component({
  selector: 'app-not-found',
  templateUrl: './not-found.component.html',
  styleUrls: [ './not-found.component.css' ]
})
export class NotFoundComponent implements OnInit {

  constructor(private _titleService: Title, private _metaService: Meta) { 
    this._titleService.setTitle("Not Found - RestCase");
    this._metaService.addTags([
      {name: 'description', content: 'The page you were looking for were not found, sorry.'}
    ], true);
  }

  ngOnInit() {
  } 

}
